import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import './Hero.css';

function Hero() {
  const { t } = useTranslation();

  const scrollToProblem = (e) => {
    e.preventDefault();
    const el = document.getElementById('problem');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="top" className="hero">
      <h1 className="hero-title">
        <Trans
          i18nKey="hero.headline"
          components={{ em: <em /> }}
        />
      </h1>
      <p className="hero-desc">{t('hero.description')}</p>
      <a href="#problem" className="hero-cta" onClick={scrollToProblem}>
        {t('hero.cta')}
      </a>
      <p className="hero-note">{t('hero.note')}</p>
    </section>
  );
}

export default Hero;
